module.exports = __webpack_public_path__ + "img/CM-MC-25-Toyota-Established.cca555ea.jpg";